export const CUSTOM_DASHBOARD_BREADCRUMB = {
  title: "Custom Dashboards",
  path: () => "/app/dashboards?tab=custom",
};
